import React, { forwardRef } from "react";
import "./LoadingElement.css";
import { LinearProgress } from "@mui/material";

const SHIRT_ICON_PATH = "/images/shirt.svg";

interface LoadingElementProps extends React.HTMLAttributes<HTMLDivElement> {
  colorHex?: string;
  transparent?: boolean;
  showProgressBar?: boolean;
  progressBarValue?: number;
}

const LoadingElement = forwardRef<HTMLDivElement, LoadingElementProps>(
  (
    {
      className,
      transparent,
      showProgressBar,
      progressBarValue,
      colorHex,
      ...rest
    },
    ref
  ) => {
    const loaderColor = colorHex ?? "#4b5563";

    return (
      <div
        ref={ref}
        id="preloader"
        {...rest}
        className={`!mt-0 h-full w-full flex justify-center items-center flex-col flex-1 ${
          transparent ? "bg-loadingTransparent" : "bg-loading"
        } z-50 ${className ?? ""}`}
      >
        <div className={"bg-white rounded-lg h-[80px] w-[80px] flex s"}>
          <div className={"flex w-full p-2"}>
            <div
              role="img"
              aria-label="Loading shirt icon"
              className="h-full w-full"
              style={{
                backgroundColor: loaderColor,
                maskImage: `url(${SHIRT_ICON_PATH})`,
                WebkitMaskImage: `url(${SHIRT_ICON_PATH})`,
                maskRepeat: "no-repeat",
                WebkitMaskRepeat: "no-repeat",
                maskPosition: "center",
                WebkitMaskPosition: "center",
                maskSize: "contain",
                WebkitMaskSize: "contain",
              }}
            />
          </div>
        </div>
        {showProgressBar && (
          <LinearProgress
            variant={progressBarValue ? "determinate" : "indeterminate"}
            value={progressBarValue}
            sx={{ width: 100, marginTop: "24px" }}
          ></LinearProgress>
        )}
      </div>
    );
  }
);

export default LoadingElement;
